var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9C22 6.23858 17.5228 4 12 4C6.47715 4 2 6.23858 2 9C2 11.6353 6.07745 13.7944 11.25 13.9861V17C11.25 17.38 11.1298 17.9667 10.7913 18.4368C10.4804 18.8686 9.95556 19.25 9 19.25H8C7.58579 19.25 7.25 19.5858 7.25 20C7.25 20.4142 7.58579 20.75 8 20.75H9C10.4374 20.75 11.4101 20.1374 12 19.3252C12.5899 20.1374 13.5626 20.75 15 20.75H16C16.4142 20.75 16.75 20.4142 16.75 20C16.75 19.5858 16.4142 19.25 16 19.25H15C14.0444 19.25 13.5196 18.8686 13.2087 18.4368C12.8702 17.9667 12.75 17.38 12.75 17V13.9861C17.9226 13.7944 22 11.6353 22 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable1);
export default __webpack_public_path__ + "static/media/table-1.9ce1e9c93479a8aa877311fc5afd782a.svg";
export { ForwardRef as ReactComponent };